import { DEFAULT_APP_LANGUAGAE } from "@/i18n/types/app-languages.types";
import type { UserProfileFormValues } from "../schemas/user-profile-form.schema";

export const USER_PROFILE_FORM_DEFAULT_VALUES: UserProfileFormValues = {
  firstName: "",
  lastName: "",
  preferredLanguage: DEFAULT_APP_LANGUAGAE,
  avatarUrl: null,
  deleteAvatar: false,
};
